import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eafab8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-title-div" }
const _hoisted_2 = { class: "block-desc" }




export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTitle',
  props: {
  title: {
    type: String,
    required: true
  },
  description: {
    type: String
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_ElText = _resolveComponent("ElText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElText, { size: "large" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.title), 1)
      ]),
      _: 1
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.description), 1)
  ]))
}
}

})